export default __webpack_public_path__ + "static/media/franchise-template-4-fr.d1b4fe64.svg";